<script setup lang="ts">
const props = defineProps<{
  page: string
  title: string
  description: string
}>()

const sectionElement = ref<HTMLElement | null>(null)
useMarketingSectionView({ page: props.page, section: 'final_cta', target: sectionElement })
</script>

<template>
  <section ref="sectionElement" class="relative overflow-hidden bg-sky-blue-700 py-20">
    <div class="absolute inset-0 bg-[radial-gradient(circle_at_80%_50%,rgba(255,255,255,0.14),transparent_35%)]" />
    <div class="relative mx-auto max-w-4xl px-4 text-center sm:px-6">
      <h2 class="text-balance text-3xl font-bold tracking-[-0.025em] text-white sm:text-4xl">{{ title }}</h2>
      <p class="mx-auto mt-5 max-w-2xl text-pretty text-lg leading-8 text-sky-blue-100">{{ description }}</p>
      <MarketingCta :page="page" section="final" variant="light" class="mt-8" />
      <p class="mt-4 text-sm font-medium text-sky-blue-100">397 € par an · Garantie satisfait ou remboursé 60 jours</p>
    </div>
  </section>
</template>
